import { useAuthStore } from '../store/authStore';

/**
 * Apre un PDF protetto da JWT in una nuova tab (fetch + Blob: un link diretto
 * riceverebbe 401). `init.body` abilita gli endpoint POST che generano il PDF
 * da un payload (es. prospetto passivo); senza `init` resta il GET storico.
 */
export async function openPdfInTab(
  url: string,
  init?: { method?: string; body?: unknown },
): Promise<void> {
  const token = useAuthStore.getState().token;
  const response = await fetch(url, {
    method: init?.method ?? 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      ...(init?.body !== undefined ? { 'Content-Type': 'application/json' } : {}),
    },
    body: init?.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
  if (!response.ok) {
    throw new Error(`PDF fetch failed: ${response.status}`);
  }
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  window.open(objectUrl, '_blank');
  // NESSUN clearTimeout, e non e' una dimenticanza: qui non c'e' nemmeno un
  // componente a cui agganciarlo (e' una util). Il timer deve sopravvivere:
  // revoca l'object URL della scheda appena aperta, che il browser sta
  // ancora leggendo. Non tocca stato React — non e' la classe di timer che
  // fa uscire vitest con 1.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 30000);
}
